// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"8c13ba54","215":"b34f5d7e","334":"74ce0ed1","513":"8f141193","614":"b59c391a","640":"6aa345d8","645":"42f27ad8"}[chunkId] + ".chunk.js";
};